import type { AgGridReact } from '@ag-grid-community/react';
import type { RefObject } from 'react';

/*
  **A grid's api, addressable by the name its caller gave it.** `DataGridUnitHelper` has no other
  route to it: the api belongs to an ag-grid instance held privately inside `DataGrid`, and the
  UnitHelper registry refuses to mock `DataGrid` precisely so that tests come through the helper.
  Without this, the only object ever handed the api is a cell renderer - which is how a test ended
  up tracking one, and why `trackComponent` needed a selector-less mode to make that possible.

  **The ref rather than the api itself**, because the api does not exist until the grid has
  started, which is after the effect that registers it.
*/
const gridRefsByName = new Map<string, RefObject<AgGridReact | null>>();

export const DataGridApiRegistry = {
  register({
    name,
    ref,
  }: {
    name: string;
    ref: RefObject<AgGridReact | null>;
  }) {
    gridRefsByName.set(name, ref);
  },

  unregister({ name }: { name: string }) {
    gridRefsByName.delete(name);
  },

  /** The live api for a mounted grid, or `undefined` while there is no such grid on screen. */
  get({ name }: { name: string }) {
    return gridRefsByName.get(name)?.current?.api;
  },
};
